(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sl-navigation')) {
    customElements.define('sl-navigation', class extends HTMLElement {
      connectedCallback() {
        this.root = this.querySelector('[data-sl-root]');
        this.trigger = this.root?.querySelector(':scope > summary');
        this.panel = this.root?.querySelector(':scope > .sl-mega');
        if (!this.root || !this.trigger || !this.panel) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.desktop = this.dataset.mode === 'desktop';
        this.viewport = matchMedia('(min-width: 750px)');
        this.hover = matchMedia('(hover: hover) and (pointer: fine)');
        this.trigger.setAttribute('aria-expanded', String(this.root.open));

        this.root.addEventListener('toggle', () => {
          this.trigger.setAttribute('aria-expanded', String(this.root.open));
          if (!this.desktop) this.trigger.setAttribute('aria-label', (document.documentElement.lang || '').toLowerCase().startsWith('sv') ? (this.root.open ? 'Stäng meny' : 'Öppna meny') : (this.root.open ? 'Luk menu' : 'Åbn menu'));
          if (this.root.open) this.measure();
        }, { signal });
        this.trigger.addEventListener('pointerenter', () => {
          if (!this.desktop || !this.hover.matches) return;
          clearTimeout(this.closeTimer);
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => this.open(), 100);
        }, { signal });
        this.addEventListener('pointerleave', () => {
          if (!this.desktop || !this.hover.matches) return;
          clearTimeout(this.openTimer);
          this.closeTimer = setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
          }, 200);
        }, { signal });
        this.panel.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), { signal });
        this.addEventListener('focusin', () => clearTimeout(this.closeTimer), { signal });
        this.addEventListener('focusout', () => {
          clearTimeout(this.focusTimer);
          this.focusTimer = setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
          }, 0);
        }, { signal });
        this.addEventListener('click', event => {
          if (event.target.closest('[data-sl-close]')) this.close(true);
          if (event.target.closest('[data-sl-backdrop]')) this.close(true);
          if (event.target.closest('a[href]')) this.close();
        }, { signal });
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.close();
        }, { signal });
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.root.open) {
            event.preventDefault();
            this.close(true);
          }
        }, { signal });
        this.trigger.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.open();
            this.panel.querySelector('a[href], button, summary')?.focus();
          }
        }, { signal });
        window.addEventListener('resize', () => {
          if (this.desktop !== this.viewport.matches) this.close();
          else if (this.root.open) this.measure();
        }, { signal, passive: true });
        window.addEventListener('scroll', () => {
          if (!this.root.open || this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.measure(); });
        }, { signal, passive: true });
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(this)) this.close();
        }, { signal });
      }
      measure() {
        const row = this.closest('.header__row');
        const top = Math.max(0, row?.getBoundingClientRect().bottom || 0);
        this.root.style.setProperty('--sl-panel-top', `${top}px`);
      }
      open() {
        if (this.desktop !== this.viewport.matches) return;
        clearTimeout(this.closeTimer);
        document.querySelectorAll('sl-navigation').forEach(menu => {
          if (menu !== this && typeof menu.close === 'function') menu.close();
        });
        this.measure();
        this.root.open = true;
        this.trigger.setAttribute('aria-expanded', 'true');
      }
      close(restoreFocus = false) {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        if (!this.root?.open) return;
        this.root.open = false;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.trigger.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        clearTimeout(this.focusTimer);
        cancelAnimationFrame(this.frame);
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
